export default function Footer() {
    return <footer>I am a Footer</footer>;
}